export default __webpack_public_path__ + "static/media/masala-tea-bags.130b532b.jpg";